import React from 'react';
import Truncate from 'src/components/truncate';

import { Row, Col, 
  Card,
  Accordion
} from 'react-bootstrap';
import cx from 'classnames';

import styles from './styles.module.scss';
import ContactAssetShareView from '../Contacts/ContactAssetShareView';
import AssetShareView from '../AssetShareView/AssetShareView';
import { localizedStrings } from 'src/localization/index.jsx';
import AccordianHeader from '../Contacts/components/AccordionHeader';

class SectionShareView extends React.Component {
  constructor(props) {
    super(props);

    this.handleSectionClicked = this.handleSectionClicked.bind(this);

    // localized contents
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
  }

  handleSectionClicked() {
    if(this.props.section.fetched){
      return;
    }
    
    this.props.fetchShareSection(this.props.conversation.id, this.props.section.id).then(() => {
      this.setState({
        loadAnalytics: true
      })
    });
  }

  render() {
    if (!this.props.section) {
      return null;
    }

    const timeSpent = this.props.section.totalTimeSpent || 0;
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }
    
    var sectionHeader = (
      <Row className={cx(styles.section)}>
        <Col md={8} className={cx(styles.sectionMetaData)}>
         
              <div className={cx(styles.name)}>
                <Truncate lines={1}>{this.props.section.name}</Truncate>
              </div>
              <div className={cx(styles.assetCount)}>{`${this.props.section.assetsCount || 0} ${this.localizedKeywords.assets}`}</div>
        
        </Col>
        <Col md={4} className={styles.metricsContainer}>
          <div className={styles.metrics}>
            <span className="paperflite-eye"></span>
            <label>{this.props.section.assetViewedCount || 0}</label>
          </div>
        </Col>
      </Row>
    );

    return (
      <Accordion
        // defaultActiveKey="0"
        className={this.props.className}
        onSelect={this.handleSectionClicked}
        >
        <Card className={styles.accordianCard}>
        <AccordianHeader eventKey={this.props.section.id}>
        {sectionHeader}
        </AccordianHeader>
        </Card>
        <Accordion.Collapse eventKey={this.props.section.id}>
        <Card.Body className={styles.assetSectionBody}>
        {this.renderAssets()}
        </Card.Body>
        </Accordion.Collapse>
      </Accordion>
    );
  }

  renderAssets() {
    if(this.props.section.loading){
      return <div className={styles.loading}>{this.localizedLoading.assets}...</div>
    }

    if(this.props.renderWithin === 'contact') {
      var assets = this.props.section.assets || [];
      assets = assets.map((asset) => {
        return <ContactAssetShareView className={styles.asset} 
        key={asset.id}
        sectionId={this.props.section.id}
        asset={asset} events={asset.events}
        shouldFetchAnalytics={true}
        renderWithin={this.props.renderWithin}
        fetchAssetAnalytics={this.props.fetchAssetAnalytics}
        fetchPreviewAsset={this.props.fetchPreviewAsset}
        

         />
      });
    }

    if(this.props.renderWithin === "conversation") {
      var assets = this.props.section.assets || [];
      assets = assets.map((asset) => {
        return <AssetShareView className={styles.asset} 
          key={asset.id}
          sectionId={this.props.section.id}
          asset={asset} events={asset.events}
          shouldFetchAnalytics={true}
          renderWithin={this.props.renderWithin}
          fetchAssetAnalytics={this.props.fetchAssetAnalytics}
          fetchPreviewAsset={this.props.fetchPreviewAsset}
          showAnalytics={true}
          />
      });
    }
    return assets;
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = '';
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join('0');
    }

    return padding + number;
  }
}

export default SectionShareView;
